import type { RouteObject } from 'react-router';

import { CaseDetailPage } from './CaseDetail';

/**
 * `/cases/:caseId` — one case.
 *
 * Three breadcrumb levels, because `/cases` is a real route in the sitemap; the
 * pack's `cases/` folder is not one and never becomes a crumb.
 *
 * It adds no loader. The console layout route runs the guard chain, and the gate
 * that binds is the owning service's: `operator` and above for the queue, the
 * thread, and the state control alike. There is no narrower role on this
 * surface — the two acts it carries are the same act's two halves.
 */
export const caseDetailRoute: RouteObject = {
  path: 'cases/:caseId',
  element: <CaseDetailPage />,
};
